import { Component, Input, OnChanges } from '@angular/core';

import { enumPaymentState } from '@data-layer/enums/payments/enumPaymentState';
import { enumIsfState } from '@data-layer/enums/isf/enumIsfState';
import { IsfStatusHelper } from '@helpers/isf-status.helper';
import { IsfModel, IsfShortModel } from '@data-layer/models/isf';

@Component({
  selector: 'isf-status',
  templateUrl: './isf-status.component.html',
  styleUrls: ['./isf-status.component.scss'],
})
export class IsfStatusComponent implements OnChanges {
  @Input() public state: enumIsfState;
  @Input() public paymentState: enumPaymentState;
  @Input() public isf: IsfModel | IsfShortModel;
  @Input() public showSecondTextForDeleted = false;

  public firstText: string = null;
  public secondText: string = null;
  public firstTextColor: string = null;
  public pointColor: string = null;

  constructor() {}

  public ngOnChanges() {
    this.firstText = IsfStatusHelper.getFirstText(this.isf.state, this.isf.paymentState, this.isf.customState);
    this.firstTextColor = IsfStatusHelper.getFirstTextColor(this.isf.state, this.isf.paymentState);
    this.secondText = IsfStatusHelper.getSecondText(
      this.isf.state,
      this.isf.paymentState,
      this.isf.valid,
      (this.isf as IsfShortModel).sentWithoutConsolidator,
      (this.isf as IsfShortModel).sentWithoutStuffingLocation,
      this.showSecondTextForDeleted,
    );
    this.pointColor = IsfStatusHelper.getPointColor(
      this.isf.state,
      this.isf.paymentState,
      this.isf.valid,
      (this.isf as IsfShortModel).sentWithoutConsolidator,
      (this.isf as IsfShortModel).sentWithoutStuffingLocation,
    );
  }
}
